module.exports = __webpack_public_path__ + "img/copy_filled_64.62935a5c.svg";